module.exports = __webpack_public_path__ + "static/media/Nirmal-Gram-Purskar-Identy-card.9df48f30.jpeg";